// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../CourseImages/CeoMsgBg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
html, body {
    margin: 0;
    padding: 0;
    font-family: 'Baumans';
    background-color: #e0f7fa;
    box-sizing: border-box;
}

/* Polymatch Background Section */
.PolymatchBgg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 5vh 0;
}

/* Polymatch Logo Section - Center content */
.PolymatchSection_11 {
    position: relative; /* Needed for the absolute positioning of the circle */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2vh;
    width: 50%;
    margin: 0 auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.PolymatchSection_11 img {
    width: 60%; /* Adjusted for better fit */
    height: auto;
    margin-top: 0;
}

/* Competition Details Section */
.PolymatchSection_12 p {
    font-family: 'Baumans', sans-serif; /* Matches the font-family */
    font-size: 35px; /* Adjusted font size */
    font-weight: 800; /* Normal font weight */
    color: rgb(139, 1, 148); /* Color as in the div */
    line-height: 1.4; /* Line height for spacing */
    white-space: pre-wrap; /* Maintains whitespace formatting */
    word-break: break-word; /* Breaks words to avoid overflow */
    margin: 0; /* Remove margins for clean text wrapping */
    width: calc(100% + 0px); /* Full-width adjustment */
    opacity: 1; /* Full visibility */
    overflow: visible; /* Ensures content visibility */
    min-width: 200px; /* Ensure a minimum width */
    min-height: 36px; /* Minimum height as per the requirement */
    height: max-content; /* Ensures the height adapts to content */
}

/* Adjust h1 to align text and provide margin */
.PolymatchSection_11 h1 {
    text-align: center;
    margin-bottom: 1rem;
}

.PolymatchSection_12 h1 {
    font-size: 3rem;
    color: #8e24aa; /* Purple theme */
    margin-bottom: 2vh;
    
    
}

.PolymatchSection_12 p {
    font-family: 'Baumans', sans-serif; /* Matches the font-family */
    font-size: 20px; /* Adjusted font size */
    font-weight: 400; /* Normal font weight */
    color: rgb(139, 1, 148); /* Color as in the div */
    line-height: 1.4; /* Line height for spacing */
    white-space: pre-wrap; /* Maintains whitespace formatting */
    word-break: break-word; /* Breaks words to avoid overflow */
    margin: 0; /* Remove margins for clean text wrapping */
    width: calc(100% + 0px); /* Full-width adjustment */
    opacity: 1; /* Full visibility */
    overflow: visible; /* Ensures content visibility */
    min-width: 200px; /* Ensure a minimum width */
    min-height: 36px; /* Minimum height as per the requirement */
    height: max-content; /* Ensures the height adapts to content */
}


.PolymatchSection_12 a {
    color: #8e24aa;
    text-decoration: none;
    font-size: 2vh;
}

.PolymatchSection_12 a:hover {
    text-decoration: underline;
}

/* Text container - to ensure the logo and text don't overlap */
.PolymatchSection_12 {
    position: relative;
    margin-top: 20px;
    padding: 0 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* New container to hold the text and the date circle */
.polymatch-text-container {
    display: flex;
    align-items: center; /* Aligns text and circle vertically */
    justify-content: flex-start; /* Ensures content starts from the left */
    position: relative;
}

.event-date-circle {
    position: absolute; /* Absolute positioning to control the exact position */
    top: 75%; /* Vertically align in the middle of the container */
    right: 150px; /* Adjust the distance from the right edge */
    transform: translateY(-50%); /* Center the circle vertically */
    background-color: #9c27b0;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.2rem;
    text-align: center;
    font-weight: bold;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Disclaimers Section */
.detail-section {
    width: 80%;
    margin: 5vh auto;
    border-radius: 15px;
    padding: 4vh;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: justify;
}

.detail-section h1 {
    
    color: rgb(139, 1, 148);
    margin-bottom: 15px;
    font-family: 'Baumans';
    font-size: 2rem;
    margin-bottom: 2vh;
    border-radius: 15px;
    text-align: center;
}

.detail-section p {
    font-size: 1.1rem;
    color: #555;
    margin-bottom: 2vh;
    justify-content: flex-end;
    align-items: center;
}

.detail-section p strong {
    color: #e53935; /* Highlight disclaimers */
}

/* Footer */
footer {
    margin-top: 5vh;
    padding: 20px;
    background-color: #c5e1a5;
    text-align: center;
    color: #333;
    font-size: 1rem;
    border-top: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/PolymatchDetail.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,iCAAiC;AACjC;IACI,iFAA6E;IAC7E,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB,EAAE,sDAAsD;IAC1E,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,UAAU,EAAE,4BAA4B;IACxC,YAAY;IACZ,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,kCAAkC,EAAE,4BAA4B;IAChE,eAAe,EAAE,uBAAuB;IACxC,gBAAgB,EAAE,uBAAuB;IACzC,uBAAuB,EAAE,wBAAwB;IACjD,gBAAgB,EAAE,4BAA4B;IAC9C,qBAAqB,EAAE,oCAAoC;IAC3D,sBAAsB,EAAE,mCAAmC;IAC3D,SAAS,EAAE,2CAA2C;IACtD,uBAAuB,EAAE,0BAA0B;IACnD,UAAU,EAAE,oBAAoB;IAChC,iBAAiB,EAAE,+BAA+B;IAClD,gBAAgB,EAAE,2BAA2B;IAC7C,gBAAgB,EAAE,0CAA0C;IAC5D,mBAAmB,EAAE,yCAAyC;AAClE;;AAEA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc,EAAE,iBAAiB;IACjC,kBAAkB;;;AAGtB;;AAEA;IACI,kCAAkC,EAAE,4BAA4B;IAChE,eAAe,EAAE,uBAAuB;IACxC,gBAAgB,EAAE,uBAAuB;IACzC,uBAAuB,EAAE,wBAAwB;IACjD,gBAAgB,EAAE,4BAA4B;IAC9C,qBAAqB,EAAE,oCAAoC;IAC3D,sBAAsB,EAAE,mCAAmC;IAC3D,SAAS,EAAE,2CAA2C;IACtD,uBAAuB,EAAE,0BAA0B;IACnD,UAAU,EAAE,oBAAoB;IAChC,iBAAiB,EAAE,+BAA+B;IAClD,gBAAgB,EAAE,2BAA2B;IAC7C,gBAAgB,EAAE,0CAA0C;IAC5D,mBAAmB,EAAE,yCAAyC;AAClE;;;AAGA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,+DAA+D;AAC/D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,mBAAmB,EAAE,sCAAsC;IAC3D,2BAA2B,EAAE,yCAAyC;IACtE,kBAAkB;AACtB;;AAEA;IACI,kBAAkB,EAAE,uDAAuD;IAC3E,QAAQ,EAAE,oDAAoD;IAC9D,YAAY,EAAE,4CAA4C;IAC1D,2BAA2B,EAAE,iCAAiC;IAC9D,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA,wBAAwB;AACxB;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc,EAAE,0BAA0B;AAC9C;;AAEA,WAAW;AACX;IACI,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC","sourcesContent":["/* General Styles */\nhtml, body {\n    margin: 0;\n    padding: 0;\n    font-family: 'Baumans';\n    background-color: #e0f7fa;\n    box-sizing: border-box;\n}\n\n/* Polymatch Background Section */\n.PolymatchBgg {\n    background: url('../CourseImages/CeoMsgBg.png') no-repeat center center fixed;\n    background-size: cover;\n    background-position: center;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 5vh 0;\n}\n\n/* Polymatch Logo Section - Center content */\n.PolymatchSection_11 {\n    position: relative; /* Needed for the absolute positioning of the circle */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 2vh;\n    width: 50%;\n    margin: 0 auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.PolymatchSection_11 img {\n    width: 60%; /* Adjusted for better fit */\n    height: auto;\n    margin-top: 0;\n}\n\n/* Competition Details Section */\n.PolymatchSection_12 p {\n    font-family: 'Baumans', sans-serif; /* Matches the font-family */\n    font-size: 35px; /* Adjusted font size */\n    font-weight: 800; /* Normal font weight */\n    color: rgb(139, 1, 148); /* Color as in the div */\n    line-height: 1.4; /* Line height for spacing */\n    white-space: pre-wrap; /* Maintains whitespace formatting */\n    word-break: break-word; /* Breaks words to avoid overflow */\n    margin: 0; /* Remove margins for clean text wrapping */\n    width: calc(100% + 0px); /* Full-width adjustment */\n    opacity: 1; /* Full visibility */\n    overflow: visible; /* Ensures content visibility */\n    min-width: 200px; /* Ensure a minimum width */\n    min-height: 36px; /* Minimum height as per the requirement */\n    height: max-content; /* Ensures the height adapts to content */\n}\n\n/* Adjust h1 to align text and provide margin */\n.PolymatchSection_11 h1 {\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.PolymatchSection_12 h1 {\n    font-size: 3rem;\n    color: #8e24aa; /* Purple theme */\n    margin-bottom: 2vh;\n    \n    \n}\n\n.PolymatchSection_12 p {\n    font-family: 'Baumans', sans-serif; /* Matches the font-family */\n    font-size: 20px; /* Adjusted font size */\n    font-weight: 400; /* Normal font weight */\n    color: rgb(139, 1, 148); /* Color as in the div */\n    line-height: 1.4; /* Line height for spacing */\n    white-space: pre-wrap; /* Maintains whitespace formatting */\n    word-break: break-word; /* Breaks words to avoid overflow */\n    margin: 0; /* Remove margins for clean text wrapping */\n    width: calc(100% + 0px); /* Full-width adjustment */\n    opacity: 1; /* Full visibility */\n    overflow: visible; /* Ensures content visibility */\n    min-width: 200px; /* Ensure a minimum width */\n    min-height: 36px; /* Minimum height as per the requirement */\n    height: max-content; /* Ensures the height adapts to content */\n}\n\n\n.PolymatchSection_12 a {\n    color: #8e24aa;\n    text-decoration: none;\n    font-size: 2vh;\n}\n\n.PolymatchSection_12 a:hover {\n    text-decoration: underline;\n}\n\n/* Text container - to ensure the logo and text don't overlap */\n.PolymatchSection_12 {\n    position: relative;\n    margin-top: 20px;\n    padding: 0 5%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* New container to hold the text and the date circle */\n.polymatch-text-container {\n    display: flex;\n    align-items: center; /* Aligns text and circle vertically */\n    justify-content: flex-start; /* Ensures content starts from the left */\n    position: relative;\n}\n\n.event-date-circle {\n    position: absolute; /* Absolute positioning to control the exact position */\n    top: 75%; /* Vertically align in the middle of the container */\n    right: 150px; /* Adjust the distance from the right edge */\n    transform: translateY(-50%); /* Center the circle vertically */\n    background-color: #9c27b0;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-size: 1.2rem;\n    text-align: center;\n    font-weight: bold;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Disclaimers Section */\n.detail-section {\n    width: 80%;\n    margin: 5vh auto;\n    border-radius: 15px;\n    padding: 4vh;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-align: justify;\n}\n\n.detail-section h1 {\n    \n    color: rgb(139, 1, 148);\n    margin-bottom: 15px;\n    font-family: 'Baumans';\n    font-size: 2rem;\n    margin-bottom: 2vh;\n    border-radius: 15px;\n    text-align: center;\n}\n\n.detail-section p {\n    font-size: 1.1rem;\n    color: #555;\n    margin-bottom: 2vh;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.detail-section p strong {\n    color: #e53935; /* Highlight disclaimers */\n}\n\n/* Footer */\nfooter {\n    margin-top: 5vh;\n    padding: 20px;\n    background-color: #c5e1a5;\n    text-align: center;\n    color: #333;\n    font-size: 1rem;\n    border-top: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
